// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCockpitNotificationsListRequestModel from '../../model/get-cockpit-notifications-list-request-model';
import GetCockpitNotificationsListRequestDTO from '../dto/get-cockpit-notifications-list-request-dto';
import dtoSchema from '../schemas/get-cockpit-notifications-list-request-schema';

export default abstract class GetCockpitNotificationsListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCockpitNotificationsListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.searchCriteria = data.searchCriteria;
      this.from = data.from;
      this.until = data.until;
      this.recipientId = data.recipientId;
      this.creatorId = data.creatorId;
      this.statesIds = data.statesIds;
      this.templateIds = data.templateIds;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  searchCriteria?: string;
  /**
  * @type {date-time}
  */
  from?: string;
  /**
  * @type {date-time}
  */
  until?: string;
  /**
  * @type {int32}
  */
  recipientId?: number;
  /**
  * @type {int32}
  */
  creatorId?: number;
  /**
  */
  statesIds?: number[];
  /**
  */
  templateIds?: number[];

  static toModel(dto: DeepPartial<GetCockpitNotificationsListRequestDTO>): GetCockpitNotificationsListRequestModel;
  static toModel(dto: DeepPartial<GetCockpitNotificationsListRequestDTO> | undefined | null): GetCockpitNotificationsListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCockpitNotificationsListRequestDTO> | undefined | null): GetCockpitNotificationsListRequestModel | undefined {
    return dto ? new GetCockpitNotificationsListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCockpitNotificationsListRequestModel> | GetCockpitNotificationsListRequestModel): GetCockpitNotificationsListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      searchCriteria: unwrapped.searchCriteria,
      from: unwrapped.from,
      until: unwrapped.until,
      recipientId: unwrapped.recipientId,
      creatorId: unwrapped.creatorId,
      statesIds: unwrapped.statesIds,
      templateIds: unwrapped.templateIds,
    } as GetCockpitNotificationsListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCockpitNotificationsListRequestModel, can not map to GetCockpitNotificationsListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
